import React from 'react';
import SEOHead from './components/SEOHead';
import { SITE_URL } from './utils/seo';
import MainHeader from './header/MainHeader';
import Footer from './footer/Footer';
import { useTranslation } from 'react-i18next';

function AboutUs() {
  const { t } = useTranslation();

  return (
    <div>
      <SEOHead
        title="Rreth Nesh - AutoPlace | Platforma #1 e Makinave në Shqipëri"
        description="AutoPlace është platforma më e besueshme për blerjen dhe shitjen e makinave në Shqipëri. Mëso më shumë rreth misionit tonë dhe ekipit tonë."
        canonical={`${SITE_URL}/about-us`}
      />
      <MainHeader />

      {/* ===== Hero Section ===== */}
      <div className="mysearch-section">
        <div className="mysearch-content">
          <h1>{t('about.title')}</h1>
        </div>
      </div>

      <section className="section_all " id="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section_title_all text-center">
                <h2 className="font-weight-bold">
                  {t('about.welcome')} <span className="text-custom">{t('about.lorem')}</span>
                </h2>
                <p className="section_subtitle col-lg-8">
                  {t('about.intro')}
                </p>
              </div>
            </div>
          </div>

          <div className="row vertical_content_manage">
            <div className="col-lg-6">
              <div className="about_header_main mt-3">
                <h2 className="font-weight-bold ">
                  {t('about.body1')}
                </h2>
                <p className="section_subtitle mt-3">
                  {t('about.para1')}
                </p>

                <p className="section_subtitle mt-3">
                  {t('about.para2')}
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="img_about mt-3">
                <img
                  src="https://i.ibb.co/qpz1hvM/About-us.jpg"
                  alt=""
                  className="img-fluid mx-auto d-block"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default AboutUs;
